export default {
  routerName: "management",
  routes: [
    {
      path: "/management/role",
      component: () => import("../management-role-view"),
    },
  ],
};
